/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable camelcase */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import useDebouncedEffect from './useDebouncedEffect';

// Brandfolder api key
const BRANDFOLDER_API_KEY = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJvcmdhbml6YXRpb25fa2V5IjoicTlrbTd0LWdpN3M2MC01b2V2OHIiLCJ1c2VyX2tleSI6IjN2OWZrdjNzNDY3d3Budm01M3NwZnA3eCIsInN1cGVydXNlciI6ZmFsc2V9.lIONCjW3NFFqeFZ3pb557NSk15M8ZPZIQmpnlgiXZLQ';

const altTextKey = 'Alt Text (125 characters max)';
const creditPhotoKey = 'Credit/Photographer';

const getAssets = async (search, endpoint, getAttachments = false) => {
  const url = `${endpoint}?search=${search}&fields=cdn_url&include=custom_fields${getAttachments ? ',attachments' : ''}`;
  const response = await fetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${BRANDFOLDER_API_KEY}`,
    },
  });
  const result = await response.json();
  return result;
};

const Main = ({ plugin }) => {
  const [searchVal, setSearchVal] = useState('');
  const [searchPdf, setSearchPdf] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [fieldValue, setFieldValue] = useState(
    JSON.parse(plugin.getFieldValue(plugin.fieldPath)),
  );
  const [attachmentList, setAttachmentList] = useState([]);
  const [customFieldList, setCustomFieldList] = useState([]);


  const searchInputChangeHandler = (event) => {
    const searchValue = event.target.value;
    setSearchPdf(searchValue.includes('[pdf]'));
    setSearchVal(searchValue.replace('[pdf]', ''));
  };

  const findMatchedCustomField = (selected, customFieldKey) => (
    customFieldList && customFieldList.find(field => field.attributes.key === customFieldKey)
    // customFieldList && customFieldList.find(alt => selected
    // ?.relationships?.custom_field_values.data
    // .find(field => field.id === alt.id && alt.attributes.key === customFieldKey))
  );

  const selectAttachment = (newVal) => {
    const altText = findMatchedCustomField(newVal, altTextKey);
    const creditPhoto = findMatchedCustomField(newVal, creditPhotoKey);

    const modifiedVal = { ...newVal };
    modifiedVal.alt_text = altText ? altText.attributes.value : '';
    modifiedVal.caption = creditPhoto ? creditPhoto.attributes.value : '';
    if (modifiedVal?.attributes) {
      modifiedVal.attributes.name = modifiedVal?.attributes?.name
        || modifiedVal?.attributes?.filename || '';
    }

    if (creditPhoto) modifiedVal.credit_photo = creditPhoto.attributes.value;

    console.log({
      newVal, modifiedVal, altText, creditPhoto, customFieldList,
    });
    setFieldValue({ ...modifiedVal, relationships: {} });
    setAttachmentList([]);
    setCustomFieldList([]);
    setSearchVal('');
    setSearchPdf(false);
  };
  useDebouncedEffect(() => {
    plugin.setFieldValue(plugin.fieldPath, JSON.stringify({
      ...fieldValue, relationships: {},
    }, null, 2));
  }, 300, [fieldValue]);
  useDebouncedEffect(
    () => {
      setError('');
      if (searchVal) {
        setLoading(true);
        setAttachmentList([]);
        (async () => {
          try {
            const assetsResults = await getAssets(
              searchVal,
              plugin.parameters.global.brandfolderEndpoint,
              true,
            );
            if (assetsResults.meta.total_count === 0) {
              setError('Assets not found.');
            }
            if (searchPdf) {
              setAttachmentList(assetsResults.included.filter(attachment => attachment.attributes.mimetype === 'application/pdf'));
            } else {
              const mappedAttachments = assetsResults.included?.filter(attachment => typeof attachment.attributes.mimetype !== 'undefined'
                && attachment.attributes.mimetype.includes('image') && Number(attachment.attributes.position) > 0)
                .map((attachment) => {
                  const originalAsset = assetsResults.data
                    .find(asset => asset.relationships.attachments.data
                      .findIndex(relationship => relationship.id === attachment.id) >= 0);

                  return ({
                    ...attachment,
                    attributes: {
                      ...attachment.attributes,
                      cdn_url: `${originalAsset.attributes.cdn_url}${originalAsset.attributes.cdn_url.indexOf('?') ? '&' : '?'}position=${attachment.attributes.position + 1}`,
                      name: originalAsset ? originalAsset.name : '',
                      description: originalAsset ? originalAsset.description : '',
                    },
                  });
                });
              setAttachmentList([...assetsResults.data, ...(mappedAttachments ?? [])]);
            }

            setCustomFieldList(assetsResults?.included?.filter(
              element => element.attributes.key === altTextKey
                || element.attributes.key === creditPhotoKey
            ));
          } catch (e) {
            console.log(e);
            setError('Error requesting data');
          } finally {
            setLoading(false);
          }
        })();
      } else {
        setAttachmentList([]);
        setCustomFieldList([]);
      }
    },
    500,
    [searchVal],
  );
  const imageUrl = fieldValue?.attributes?.cdn_url ?? fieldValue?.attributes?.thumbnail_url;
  return (
    <>
      {fieldValue && fieldValue.attributes ? (
        <>
          <div className="selected">
            <img alt="Selected Asset" src={`${imageUrl}${imageUrl.indexOf('?') !== -1 ? '&' : '?'}width=160`} />
            <p>{fieldValue.attributes.name}</p>
            <i tabIndex="-1" role="button" onClick={() => selectAttachment({})}>
              X
            </i>
          </div>
          <div className="edit">
            <div>
              <p>{altTextKey}</p>
              <input
                type="text"
                value={fieldValue.alt_text ? fieldValue.alt_text : ''}
                onChange={e => setFieldValue({ ...fieldValue, alt_text: e.target.value })}
              />
            </div>
          </div>
          <div className="edit">
            <div>
              <p>Image Credit</p>
              <input
                type="text"
                value={fieldValue.caption ? fieldValue.caption : ''}
                onChange={e => setFieldValue({ ...fieldValue, caption: e.target.value })}
              />
            </div>
          </div>
        </>
      ) : (
        <>
          <input
            placeholder="Search for assets..."
            onChange={searchInputChangeHandler}
          />
          {loading && <p className="loading">Searching...</p>}
          {error && <p className="error">{error}</p>}
          {attachmentList.length > 0 && (
            <div className="results">
              {attachmentList
                .map(attachment => (
                  <div
                    key={attachment.id}
                    tabIndex="-1"
                    role="button"
                    onClick={() => selectAttachment(attachment)}
                  >
                    {attachment.attributes.thumbnail_url && (
                      <img
                        alt={attachment.attributes.name || attachment.attributes.filename}
                        src={attachment.attributes.thumbnail_url}
                      />
                    )}
                    <p>{`${attachment.attributes.name || attachment.attributes.filename}`}</p>
                  </div>
                ))}
            </div>
          )}
        </>
      )}
    </>
  );
};

Main.propTypes = {
  plugin: PropTypes.object,
};

export default Main;
